import { PropsWithChildren, createContext, useState } from 'react';

import { useLanguage } from './useLanguage';

export const LocalizationContext = createContext({
	languageID: '',
	setLanguageID: (languageID: string) => {},
});

export function LocalizationScope(props: PropsWithChildren<{ initialLanguageID?: string }>) {
	const language = useLanguage();

	const [languageID, setLanguageID] = useState(props.initialLanguageID || language.id);

	return (
		<LocalizationContext.Provider value={{ languageID, setLanguageID }}>
			{props.children}
		</LocalizationContext.Provider>
	);
}
